/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';

import {ChartService} from './chart.service';
import {DonutChartComponent} from './d3/donut-chart.component';
import {PieChartComponent} from './d3/pie-chart.component';
import {EChartComponent} from './echarts/echarts.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DonutChartComponent, PieChartComponent, EChartComponent],
  exports: [DonutChartComponent, PieChartComponent, EChartComponent],
  providers: []
})
export class ChartsModule {
  public static forRoot(): ModuleWithProviders<ChartsModule> {
    return {
      ngModule: ChartsModule,
      providers: [
        ChartService
      ]
    };
  }
}
